import React, {Component} from 'react';
import {Menu} from 'antd';
import {
	PieChartOutlined,
	DesktopOutlined,
	ContainerOutlined,
	MailOutlined,
} from '@ant-design/icons';

const {SubMenu} = Menu;

class LeftMenu extends Component {
	state = {
		collapsed: false,
	};

	toggleCollapsed = () => {
		this.setState({
			collapsed: !this.state.collapsed,
		});
	};

	render() {
		return (
			<div style={{width: 256}}>
				<Menu
					defaultSelectedKeys={['0']}
					defaultOpenKeys={['']}
					mode="inline"
					theme="light"
					inlineCollapsed={this.state.collapsed}
				>
					<Menu.Item key="1" icon={<DesktopOutlined/>}>
						<a>Thị trường</a>
					</Menu.Item>
					<Menu.Item key="2" icon={<ContainerOutlined/>}>
						<a>Giao dịch</a>
					</Menu.Item>
					<SubMenu key="sub1" icon={<MailOutlined/>} title="Ngôn ngữ">
						<Menu.Item key="3">Tiếng Anh</Menu.Item>
						<Menu.Item key="4">Tiếng Trung</Menu.Item>
					</SubMenu>
				</Menu>
			</div>
		);
	}
}

export default LeftMenu;
